// FrequentationGlobalStats component
// UPDATED: Analytics v3 - reduced to 3 stat cards (removed "Types de cours");
//   adapts to show global or per-mission stats depending on selection

import { Users, BarChart3, TrendingUp } from 'lucide-react';

interface FrequentationGlobalStatsProps {
  total: number;
  sessionCount: number;
  avgPerSession: number;
}

interface StatCardProps {
  icon: React.ReactNode;
  iconBg: string;
  label: string;
  value: string;
  sub: string;
}

function StatCard({ icon, iconBg, label, value, sub }: StatCardProps) {
  return (
    <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-4">
      <div className="flex items-center gap-2 mb-2">
        <div className={`w-7 h-7 rounded-lg flex items-center justify-center ${iconBg}`}>
          {icon}
        </div>
        <span className="text-xs text-gray-500 font-medium leading-tight">{label}</span>
      </div>
      <p className="text-2xl font-bold text-gray-900 leading-none">{value}</p>
      <p className="text-xs text-gray-400 mt-1">{sub}</p>
    </div>
  );
}

export function FrequentationGlobalStats({ total, sessionCount, avgPerSession }: FrequentationGlobalStatsProps) {
  return (
    <div className="grid grid-cols-3 gap-3">
      <StatCard
        icon={<Users size={14} className="text-primary-600" />}
        iconBg="bg-primary-100"
        label="Total participants"
        value={total.toLocaleString('fr-FR')}
        sub="sur la période"
      />
      <StatCard
        icon={<TrendingUp size={14} className="text-blue-600" />}
        iconBg="bg-blue-100"
        label="Moy. par séance"
        value={avgPerSession.toLocaleString('fr-FR', { maximumFractionDigits: 1 })}
        sub="participants / cours"
      />
      <StatCard
        icon={<BarChart3 size={14} className="text-amber-600" />}
        iconBg="bg-amber-100"
        label="Cours donnés"
        value={sessionCount.toLocaleString('fr-FR')}
        sub="séances au total"
      />
    </div>
  );
}
